import { ADVISORY_FORM_RESPONSE_URL } from "@/config/constants";

/** Posts answers into the existing Google Form so they land in the same spreadsheet. */
export function submitAdvisoryForm(entries: Readonly<Record<number, string>>): Promise<void> {
  return new Promise((resolve) => {
    const frameName = "advisory-form-sink";
    let frame = document.getElementById(frameName);
    if (!(frame instanceof HTMLIFrameElement)) {
      const created = document.createElement("iframe");
      created.id = frameName;
      created.name = frameName;
      created.hidden = true;
      created.setAttribute("aria-hidden", "true");
      created.tabIndex = -1;
      document.body.appendChild(created);
      frame = created;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = ADVISORY_FORM_RESPONSE_URL;
    form.target = frameName;
    form.acceptCharset = "UTF-8";
    form.hidden = true;

    for (const [entry, value] of Object.entries(entries)) {
      const trimmed = value.trim();
      if (!trimmed) continue;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `entry.${entry}`;
      input.value = trimmed;
      form.appendChild(input);
    }

    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      form.remove();
      resolve();
    };

    frame.addEventListener("load", finish, { once: true });
    document.body.appendChild(form);
    form.submit();
    window.setTimeout(finish, 4000);
  });
}
